<template>
    <a class="text" @click="submit">
        <i v-if="loading" class="fa fa-spin fa-spinner fa-fw"></i>
        <i v-else-if="checked" class="fa fa-check-square-o fa-fw" aria-hidden="true"></i>
        <i v-else class="fa fa-square-o fa-fw" aria-hidden="true"></i>
        Auf die Merkliste
    </a>
</template>
<script>
export default {
    props: {
        pid: {
            type: [String, Number],
            required: true,
            default: null
        }
    },

    data() {
        return {
            loading: false,
            checked: false,
            rowId: 0
        }
    },

    created() {
        new Form({
            pid: this.pid
        })
        .post('/api/merkliste/inlist')
        .then((response) => {
            if(response.success) {
                this.checked = true;
                this.rowId = response.rowId;
            }
        })
    },

    methods: {

        submit() {

            this.loading = true;
            if(this.checked == false) {
                new Form({
                    pid: this.pid
                })
                .post('/api/merkliste/add')
                .then((response) => {
                    this.loading = false;
                    this.checked = true;
                    this.rowId = response.rowId;
                })
            } else {
                new Form({
                    rowId: this.rowId
                })
                .post('/api/merkliste/remove')
                .then((response) => {
                    this.loading = false;
                    this.checked = false;
                })
            }
            
        }
    }
}
</script>
